// Page through a classic list endpoint until it is exhausted.
//
// Classic list routes cap pageSize server-side (devices.js clamps to 100) and
// ignore an unknown `limit`, so asking for 1000 silently returns 25 and any
// total computed from it is WRONG — the first cut of the Reconcile screen
// reported 100% coverage from 25 of 66 rows.
//
// A whole-population screen must therefore page, and must say so when it
// stops. `cap` is a guard rail, not a silent truncation: the caller gets
// `complete: false` and is expected to surface it. At 3,000 devices this is
// the difference between a number and a guess.

export default async function fetchAllPages(get, { pageSize = 100, cap = 5000 } = {}) {
  const rows = [];
  let page = 1;
  let total = null;
  let complete = true;

  for (;;) {
    const res = await get({ page, pageSize });
    const body = res?.data ?? res;
    const batch = Array.isArray(body?.data) ? body.data : [];
    rows.push(...batch);

    const pg = body?.pagination;
    total = pg?.totalCount ?? total;

    const more = pg
      ? page < (pg.totalPages ?? 1)
      : batch.length === pageSize;

    if (!more) break;
    if (rows.length >= cap) { complete = false; break; }
    page += 1;
  }

  return { rows, total: total ?? rows.length, complete };
}
